import {CardSectionTitle} from '@hconnect/uikit/src/lib2'
import {useUpmPlant} from '@hconnect/upm'
import {useHasPermission} from '@hproduce/permissions'
import {LinearProgress, Box, Divider, Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {CommentPreview} from '../../components'
import {FEATURE_NAMESPACE} from '../../consts'
import {useComments} from '../../hooks'

type CommentsProps = {
  plantId: string
  eventId: string
  timezone: string
}

export const ShiftTaskCommentsContainer: React.FC<CommentsProps> = ({
  plantId,
  eventId,
  timezone
}) => {
  const {data: comments, isLoading, isFetching} = useComments({plantId, eventId, timezone})
  const upmPlant = useUpmPlant({plantId, shouldRaiseError: false})
  const hasPermission = useHasPermission({plantId, countryId: upmPlant?.country ?? ''})
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Box>
      <Box
        sx={{
          mb: 1
        }}
      >
        <CardSectionTitle sx={{mb: 1}} data-test-id="task-comments-title">
          {t('shiftEvent.label.comments')}
          {comments && ` (${comments.length})`}
        </CardSectionTitle>
        {isFetching || isLoading ? <LinearProgress /> : <Divider sx={{borderColor: 'divider'}} />}
      </Box>
      {comments && (
        <Box my={2}>
          {hasPermission('VIEW_PLANT_EVENT_COMMENTS') && (
            <Stack spacing={2}>
              {comments.map((comment) => (
                <CommentPreview
                  key={comment.id}
                  description={comment.description}
                  creator={comment.creator}
                  createDate={comment.createDate}
                  timezone={timezone}
                  withMarkdown={true}
                  dataTestId={`task-comment-item-${comment.id}`}
                />
              ))}
            </Stack>
          )}
        </Box>
      )}
    </Box>
  )
}
